import React, { FC } from 'react';
import { Box } from '@bechtel/gds';
import { FillerMaterial } from './filler-material';
import { RodRequestStencils } from './stencils';
import { RodRequestWelds } from './welds';
import { RequestedBy } from './requested-by';
import { RodRequest } from '@bechtel/types';
import { map } from 'lodash';

interface RodRequestDetailsProps {
  rodRequest: RodRequest;
  onClose?: () => void;
}

export const RodRequestDetails: FC<RodRequestDetailsProps> = ({ rodRequest, onClose }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }} css={{ overflowY: 'auto' }}>
      <FillerMaterial fillerMaterial={rodRequest.fillerMaterials} />
      <RodRequestStencils stencils={map(rodRequest.stencils, (item) => item.stencil)} caddies={rodRequest?.caddies} />
      <RodRequestWelds welds={rodRequest.welds} />
      <RequestedBy rodRequestItem={rodRequest} onClose={onClose} />
    </Box>
  );
};
